<div class="category" [lazyLoad]="category.imageURL" [offset]="200">
  <a
    class="category__wrapper-link"
    href="/category/{{ category.ID }}"
    routerLink="/category/{{ category.ID }}"
  >
    <p class="category__name">{{ category.categoryName }}</p>
  </a>
</div>
